import BanUserModal from './BanUserModal';

export default BanUserModal;
